import { useCallback, useEffect, useState } from 'react'

export type PlatformThemeMode = 'light' | 'dark'

const STORAGE_KEY = 'agendamentos-app:platform-theme'

export const PLATFORM_THEME_CHANGE = 'platform-theme-change'

export function getPlatformTheme(): PlatformThemeMode {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light'
  } catch {
    return 'light'
  }
}

/** Aplica tema no documento (super-admin). */
export function applyPlatformDocumentTheme(mode: PlatformThemeMode): void {
  const html = document.documentElement
  html.classList.add('platform-route')
  html.setAttribute('data-platform-theme', mode)
}

export function clearPlatformDocumentTheme(): void {
  const html = document.documentElement
  html.classList.remove('platform-route')
  html.removeAttribute('data-platform-theme')
}

export function setPlatformTheme(mode: PlatformThemeMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, mode)
  } catch {
    /* ignore */
  }
  if (document.documentElement.classList.contains('platform-route')) {
    applyPlatformDocumentTheme(mode)
  }
  window.dispatchEvent(new CustomEvent(PLATFORM_THEME_CHANGE, { detail: mode }))
}

export function usePlatformTheme(): [PlatformThemeMode, (mode: PlatformThemeMode) => void] {
  const [mode, setModeState] = useState<PlatformThemeMode>(getPlatformTheme)

  useEffect(() => {
    const onChange = (e: Event) => {
      const next = (e as CustomEvent<PlatformThemeMode>).detail
      if (next === 'light' || next === 'dark') setModeState(next)
    }
    window.addEventListener(PLATFORM_THEME_CHANGE, onChange)
    return () => window.removeEventListener(PLATFORM_THEME_CHANGE, onChange)
  }, [])

  const setMode = useCallback((next: PlatformThemeMode) => {
    setPlatformTheme(next)
    setModeState(next)
  }, [])

  return [mode, setMode]
}
